/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFunnelDollar} from '@fortawesome/pro-duotone-svg-icons';

const BidCyclesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFunnelDollar} {...props} />
);

export default BidCyclesIcon;
